// import modules
import $ from 'jquery';
import lozad from 'lozad';



//import extensions
import './lib';
import './inview';
import './useragent';
// import './swiper';
// import './inquiry';



// Analyze Laptop or Mobile function
import userDevice from './useragent';
let theDevice = userDevice.analyze();



/*
 * Fix Header Position
 */
if (theDevice == 'laptop') {
  $(() => {
    let targetClassName = $('.js-menu'),
      targetClassState = 'is-fixed',
      offsetTop = 300;

    let fixHeaderPosition = () => {
      if ($(window).scrollTop() > offsetTop) {
        targetClassName.addClass(targetClassState);
      } else {
        targetClassName.removeClass(targetClassState);
      }
    }

    $(window).scroll(fixHeaderPosition);
    $('body').bind('touchmove', fixHeaderPosition);
  });
}

/*
 * Fix Position
 */
// IE11で動作不良を確認

// if (theDevice === 'laptop') {
//   const eventTargetClass = document.querySelector('.p-nav--area--top');
//   const eventTargetClassLayer = document.querySelector('.p-nav__layer');

//   if (eventTargetClass != null) {
//     document.querySelector('body').onscroll = function () {
//       const eventScrollPosition = 682;
//       const scrollPosition = document.documentElement.scrollTop;

//       if (eventScrollPosition < scrollPosition) {
//         eventTargetClass.classList.add('is-stick');
//       } else {
//         eventTargetClass.classList.remove('is-stick');
//       }
//     };
//   }
//   if (eventTargetClassLayer != null) {
//     document.querySelector('body').onscroll = function () {
//       const eventScrollPosition = 150;
//       const scrollPosition = document.documentElement.scrollTop;

//       if (eventScrollPosition < scrollPosition) {
//         eventTargetClassLayer.classList.add('is-stick');
//       } else {
//         eventTargetClassLayer.classList.remove('is-stick');
//       }
//     };
//   }
// }


if (theDevice === 'laptop') {
  $(window).scroll(function () {

    if ($(window).scrollTop() > 700) {
      $('.p-nav--area--top').addClass('is-stick');
    } else {
      $('.p-nav--area--top').removeClass('is-stick');
    }

    if ($(window).scrollTop() > 180) {
      $('.p-nav__layer').addClass('is-stick');
    } else {
      $('.p-nav__layer').removeClass('is-stick');
    }
  });
} else if (theDevice === 'mobile') {
  $(window).scroll(function () {
    if ($(window).scrollTop() > 0) {
      $('.l-header').addClass('is-stick');
    } else {
      $('.l-header').removeClass('is-stick');
    }
  });
}






/*
 * Toggle Menu
 */
$(() => {
  let targetClassName = $('.js-menu'),
    targetBtnName = $('.js-menu-btn'),
    targetClassState = 'is-open',
    targetClassFixPos = 'is-fixed',
    state = false,
    scrollPos;

  targetBtnName.on('click', openSpMenu => {
    // メニューの展開トグル
    $(openSpMenu.currentTarget).toggleClass(targetClassState);
    targetClassName.toggleClass(targetClassState);

    // メニュー展開時にメインコンテンツの位置を固定
    if (state == false) {
      scrollPos = $(window).scrollTop();
      $('body').addClass(targetClassFixPos).css({ 'top': -scrollPos });
      state = true;
    } else {
      $('body').removeClass(targetClassFixPos).css({ 'top': 0 });
      window.scrollTo(0, scrollPos);
      state = false;
    }
  });
});



/*
 * Smooth Scroll
 *********************************** */
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});



/*
 * LazyLoad (lozad.js)
 *********************************** */
let observer = lozad();
observer.observe();




/*
 * Parallax
 *********************************** */
// const parallax = () => {
$('.c-parallax').on('inview', function (event, isInView, visiblePartX, visiblePartY) {
  if (isInView) {

    $(this).find('.c-parallax__line').stop().addClass('is-slide');
    $(this).find('.c-parallax__kv').stop().addClass('is-slide');

    var delaySpeed = 1000;
    var fadeSpeed = 500;

    $(this).find('.c-parallax__item').each(function (i) {
      $(this).delay(i * (delaySpeed)).animate({ opacity: '1' }, fadeSpeed);
    });

    $(this).children().find('.c-parallax__item').each(function (i) {
      $(this).delay(i * (delaySpeed)).animate({ opacity: '1' }, fadeSpeed);
    });

  }
});
// };



/*
 * splash
 *
 * referrerが自ドメインの場合は
 * スプラッシュスクリーンは表示させない
 *********************************** */
// const referrerUrl = document.referrer;
// if (referrerUrl.indexOf('localhost') > -1) {
//   $('.p-splash').hide();
//   parallax();
// } else {
//   $(function () {   //ロード中はコンテンツの高さをページの高さに合わせる
//     var h = $(window).height();
//     // $('.l-wrap--top').css('display', 'none');
//     $('.p-splash').height(h).css('display', 'block');
//     $('.p-splash__logo').fadeIn(500).css('display', 'block');
//   });

//   $(window).on('load', function () {  //全ての読み込みが完了したら実行する
//     $('.p-splash').delay(2000).fadeOut(2000);
//     $('.p-splash__logo').delay(1000).fadeOut(1000);
//     $('.l-wrap--top').css('display', 'block');
//   });

//   const stopload = () => {
//     $('.p-splash').hide();
//     $('.l-wrap--top').show();
//   };

//   setTimeout(parallax, 3000);
//   setTimeout(stopload, 10000);
// }


// (function (win, doc) {

// "use strict";

// var arr;

// doc.write("$moveRange: 10px;");
// br();
// br();
// for (var j = 1; j < 7; ++j) {
//   document.write("@keyframes move" + j + " {");
//   br();

//   for (var i = 0; i <= 10; ++i) {
//     arr = [((Math.random() - 0.5) * 20 | 0) / 10, ((Math.random() - 0.5) * 20 | 0) / 10];
//     tab(); doc.write(i * 10 + "% {");
//     br();
//     tab(); tab(); doc.write("transform: translate3d(" + arr[0] + " * $moveRange, " + arr[1] + " * $moveRange, 0);");
//     br();
//     tab(); doc.write("}");
//     br();
//   }

//   doc.write("}");
//   br();
// }

// function br() {
//   doc.write("<br />");
// }

// function tab() {
//   doc.write("&nbsp;&nbsp;");
// }

// }) (this, document);
